import React, { useState, useEffect } from 'react';
import {
  TextInput,
  Field,
  Fieldset,
  FieldBody,
  FieldLabel,
  Button,
  Select,
  TextArea,
  Typeahead,
  TypeaheadItem,
  TypeaheadItemSuggestion,
  SearchIcon,
  Tooltip,
  TooltipContent,
  TooltipPassage,
  CircleQuestionMarkFilledIcon,
} from '@emorg-prd/react-standard';
import './index.css';
import Timezone from '../../../../api/Timezone';
import Country from '../../../../api/Country';
import CountrySubdivision from '../../../../api/CountrySubdivision';
import LatLongService from '../../../../api/LatLongService';
import CreateFromExisting from './CreateFromExisting';
import RealEstateInterestWrapper from './ReiWrapper';
import City from '../../../../api/City';
import ProgressTabNavigator from '../ProgressTabNavigator';

function CreateLocation(props) {
  const {
    locationName,
    locationStreetAddress1,
    locationStreetAddress2,
    country,
    countrySubdivision,
    locationCity,
    locationPostalCode,
    locationCounty,
    latitude,
    longitude,
    timezone,
    locationDesc,
    onChange,
    handlePageError,
    onNavigateForward,
    onSetProgressTabComplete,
    realEstateInterestList,
    showLoadingSpinner,
    locationStateLocationId,
  } = props;
  const [isCreateFromModalVisible, setCreateFromModalVisible] = useState(false);
  const [countryDropdown, setCountryDropdown] = useState([]);
  const [countrySubdivisionDropdown, setCountrySubdivisionDropdown] = useState([]);
  const [timezoneDropdown, setTimezoneDropdown] = useState([]);
  const descMax = 250;
  const [citiesDropDown, setcitiesDropdown] = useState([]);
  const [currentCountrySelected, setcurrentCountrySelected] = useState("");
  const [currentcountrySubdivisionSelected, setcurrentcountrySubdivisionSelected] = useState(null);
  useEffect(() => {
    showLoadingSpinner(true);
    window.scrollTo(0, 0);

    Timezone.getAll().then((res) => {
      res.sort((a, b) => {
        return a.timezoneName.localeCompare(b.timezoneName);
      });
      setTimezoneDropdown(res);
    }).catch((error) => {
      handlePageError(error.message);
    });

    Country.getAll().then((res) => {
      setCountryDropdown(res);
      showLoadingSpinner(false);
    }).catch((error) => {
      handlePageError(error.message);
    });

    if (country.id && countrySubdivision.id) {
      handleCitiesSuggestions(country.id, countrySubdivision.id);
    }
    else if (country.id) {
      handleCitiesSuggestions(country.id);
    }

    onSetProgressTabComplete();
  }, []);

  useEffect(() => {
    if (country.id) {
      showLoadingSpinner(true);
      CountrySubdivision.getByCountryId(country.id).then((res) => {
        setCountrySubdivisionDropdown(res.data);
        showLoadingSpinner(false);
      }).catch((error) => {
        handlePageError(error.message);
      });
    }
  }, [country]);

  const renderTimezoneDropdown = (timezone) => {
    const timezoneName = timezone.timezoneName;
    return (
      <option
        id={timezone.timezoneId}
        key={timezone.timezoneId}
        value={timezone.timezoneName}
      >
        {timezoneName}
      </option>
    );
  };

  const handleLocationNameChange = (event) => {
    onChange('locationName', event.target.value);
    const tempREIList = [...realEstateInterestList];
    tempREIList[0].realEstateInterestName = event.target.value;
    onChange('realEstateInterestList', tempREIList);
  };

  const handleDescription = (value) => {
    if (value.length <= descMax) {
      onChange('locationDesc', value);
    }
  };

  const handleCountryChange = (event) => {
    handleCountyLatLongClearFields();
    event.target.click();
    let countryId = null;
    if (event.key === 'Enter') {
      event.preventDefault();
      let countryObject = countryDropdown.find((countryOption) =>
        countryOption.countryName.toLowerCase() === country.name.toLowerCase()
      );
      if (countryObject) {
        countryId = countryObject.countryId;
        onChange('countrySubdivision', { id: null, name: '' });
        onChange('locationCity', '');
      }
      handleCitiesSuggestions(countryId);
    }
    onChange('country', { id: countryId, name: `${event.target.value}` });
    setcurrentCountrySelected(countryId);
  };

  const handleCountryClick = (e, value) => {
    let countryId = null;
    let countryObject = countryDropdown.find((country) => country.countryName === value);
    if (countryObject) {
      countryId = countryObject.countryId;
    }
    onChange('country', { id: countryId, name: `${value}` });
    onChange('countrySubdivision', { id: null, name: '' });
    onChange('locationCity', '');
    setcurrentCountrySelected(countryId);
    handleCitiesSuggestions(countryId);
  };

  const handleCountrySubdivisionClick = (e, value) => {
    let countrySubdivisionId = null;
    let countrySubdivisionObject = countrySubdivisionDropdown.find((stateOption) =>
      stateOption.countrY_SUBDIVISION_NAME === value
    );
    if (countrySubdivisionObject) {
      countrySubdivisionId = countrySubdivisionObject.countrY_SUBDIVISION_ID;
    }
    onChange('countrySubdivision', { id: countrySubdivisionId, name: `${value}` });
    setcurrentcountrySubdivisionSelected(countrySubdivisionId);
    onChange('locationCity', '');
    handleCitiesSuggestions(null, countrySubdivisionId);
  };

  const handleCountrySubdivisionChange = (event) => {
    handleCountyLatLongClearFields();
    event.target.click();
    let countrySubdivisionId = null;
    if (event.key === 'Enter') {
      event.preventDefault();
      let countrySubdivisionObject = countrySubdivisionDropdown.find((stateOption) =>
        stateOption.countrY_SUBDIVISION_NAME.toLowerCase() === event.target.value.toLowerCase()
      );
      if (countrySubdivisionObject) {
        countrySubdivisionId = countrySubdivisionObject.countrY_SUBDIVISION_ID;
        onChange('locationCity', '');
      }
      handleCitiesSuggestions(null, countrySubdivisionId);
    }
    onChange('countrySubdivision', { id: countrySubdivisionId, name: `${event.target.value}` });
    setcurrentcountrySubdivisionSelected(countrySubdivisionId);
  };

  const populateLatLong = () => {
    if (locationStreetAddress1 && locationCity && country) {
      let fullAddress =
        locationStreetAddress1 + ' ' +
        locationStreetAddress2 + ', ' +
        locationCity + ', ' +
        countrySubdivision + ' ' +
        locationPostalCode + ' ' +
        country.name;
      LatLongService.getLatLong(fullAddress)
        .then((res) => res.json())
        .then((resJson) => {
          if ('countrySecondarySubdivision' in resJson.results[0].address) {
            onChange('locationCounty', resJson.results[0].address.countrySecondarySubdivision);
          } else {
            if ('municipalitySubdivision' in resJson.results[0].address) {
              onChange('locationCounty', resJson.results[0].address.municipalitySubdivision);
            }
          }
          onChange('latitude', resJson.results[0].position.lat);
          onChange('longitude', resJson.results[0].position.lon);
        })
        .catch((error) => {
          alert('There was an error auto populating County, Latitude & Longitude.');
          onChange('locationCounty', '');
          onChange('latitude', '');
          onChange('longitude', '');
        });
    } else {
      alert(
        'Street Address 1, City, and Country are required to auto-populate County, Latitude & Longitude.'
      );
      onChange('locationCounty', '');
      onChange('latitude', '');
      onChange('longitude', '');
    }
  };

  const handleCityChange = (event) => {
    handleCountyLatLongClearFields();
    event.target.click();
    if (event.key === 'Enter') {
      event.preventDefault();
      let cityObject = citiesDropDown.find((cityOption) =>
        cityOption.locationCity.toLowerCase() === locationCity.toLowerCase()
      );
      if (cityObject) {
        onChange('locationCity', cityObject.locationCity);
      }
    }
    onChange('locationCity', event.target.value);
  };

  const handleCitiesSuggestions = (countryCode, countrySubdivisionCode) => {
    let citySearch = {
      CountryId: countryCode ? countryCode : currentCountrySelected,
      CountrySubdivisionId: countrySubdivisionCode = null ? '' : countrySubdivisionCode,
    };
    City.getCities(citySearch).then((res) => {
      setcitiesDropdown(res);
    });
  };

  const handleCityClick = (e, value) => {
    onChange('locationCity', value);
  };

  const handleCountyLatLongClearFields = () => {
    onChange('locationCounty', '');
    onChange('latitude', '');
    onChange('longitude', '');
  }

  return (
    <div className='page'>
      <Fieldset>
        <div className='input-row-with-note'>
          <TextInput
            className='location-input'
            label='Location Name *'
            placeholder=''
            error={locationName.length < 5 || locationName.length > 50}
            value={locationName}
            onChange={(e) => handleLocationNameChange(e)}
            valid={false}
            note={
              locationName.length < 5
                ? 'Minimum length of 5 characters'
                : locationName.length > 50
                  ? 'Max length of 50 characters'
                  : ''
            }
          />

          <Button
            className='small-margin'
            variant='tertiary'
            size='small'
            style={{ paddingTop: '42px', paddingLeft: '15px' }}
            onClick={() => setCreateFromModalVisible(true)}
          >
            + Create from Existing Location
          </Button>
          <CreateFromExisting
            onChange={onChange}
            handlePageError={handlePageError}
            isVisible={isCreateFromModalVisible}
            closeModal={() => setCreateFromModalVisible(false)}
            showLoadingSpinner={showLoadingSpinner}
          ></CreateFromExisting>
        </div>

        <TextInput
          className='location-input'
          label='Street Address 1 *'
          placeholder=''
          error={
            locationStreetAddress1.length < 1 ||
            locationStreetAddress1.length > 255
          }
          value={locationStreetAddress1}
          onChange={(e) => {
            onChange('locationStreetAddress1', e.target.value);
            handleCountyLatLongClearFields();
          }}
          note={
            locationStreetAddress1.length > 255
              ? 'Max length of 255 characters' : ''
          }
        />

        <TextInput
          className='location-input'
          label='Street Address 2'
          placeholder=''
          value={locationStreetAddress2}
          onChange={(e) => {
            onChange('locationStreetAddress2', e.target.value);
            handleCountyLatLongClearFields();
          }}
        />

        <div className='input-row'>
          <Field>
            {' '}
            <FieldLabel>Country *</FieldLabel>
            <FieldBody>
              <form className='search-form'>
                <div className='em-c-search__body'>
                  <Typeahead
                    className='country-state'
                    error={!country.id}
                    onChange={(e, value) => {
                      handleCountryClick(e, value);
                      handleCountyLatLongClearFields();
                    }}
                    inputProps={{
                      className: 'search-bar',
                      onChange: (e) => { handleCountryChange(e) },
                      onKeyPress: (e) => { handleCountryChange(e) },
                      value: country.name,
                      placeholder: 'Search',
                      error: !country.id,
                    }}
                  >
                    {countryDropdown
                      .filter((countries) =>
                        countries.countryName
                          ? countries.countryName.toLowerCase()
                            .slice(0, country.name.trim().toLowerCase().length)
                          === country.name.trim().toLowerCase()
                          : ''
                      )
                      .map((country) => (
                        <TypeaheadItem
                          id={country.countryId}
                          key={country.countryId}
                          value={country.countryName}
                        >
                          <TypeaheadItemSuggestion>
                            <span>{`${country.countryName} `}</span>
                          </TypeaheadItemSuggestion>
                        </TypeaheadItem>
                      ))}
                  </Typeahead>
                  <Button className='create-location-secondary'>
                    <SearchIcon size='small' />
                  </Button>
                </div>
              </form>
            </FieldBody>
          </Field>

          <Field style={{ paddingLeft: '15px' }}>
            <FieldLabel>State/Province</FieldLabel>
            <FieldBody>
              <form className='search-form'>
                <div className='em-c-search__body'>
                  <Typeahead
                    className='country-state'
                    onChange={(e, value) => {
                      handleCountrySubdivisionClick(e, value);
                      handleCountyLatLongClearFields();
                    }}
                    inputProps={{
                      className: 'search-bar',
                      onChange: (e) => handleCountrySubdivisionChange(e),
                      onKeyPress: (e) => handleCountrySubdivisionChange(e),
                      value: countrySubdivision.name,
                      placeholder: 'Search',
                    }}
                  >
                    {countrySubdivisionDropdown
                      .filter((countrySubdivisions) =>
                        countrySubdivisions.countrY_SUBDIVISION_NAME
                          ? countrySubdivisions.countrY_SUBDIVISION_NAME.toLowerCase()
                            .slice(0, countrySubdivision.name.trim().toLowerCase().length)
                          === countrySubdivision.name.trim().toLowerCase()
                          : ''
                      )
                      .map((state) => (
                        <TypeaheadItem
                          id={state.countrY_SUBDIVISION_ID}
                          key={state.countrY_SUBDIVISION_ID}
                          value={state.countrY_SUBDIVISION_NAME}
                        >
                          <TypeaheadItemSuggestion>
                            <span>{`${state.countrY_SUBDIVISION_NAME} `}</span>
                          </TypeaheadItemSuggestion>
                        </TypeaheadItem>
                      ))}
                  </Typeahead>
                  <Button className='create-location-secondary'>
                    <SearchIcon size='small' />
                  </Button>
                </div>
              </form>
            </FieldBody>
          </Field>
        </div>

        <div className='input-row'>
          <Field>
            {' '}
            <FieldLabel>City *</FieldLabel>
            <FieldBody>
              <form className='search-form'>
                <div className='em-c-search__body'>
                  <Typeahead
                    className='country-state'
                    onChange={(e, value) => {
                      handleCityClick(e, value);
                      handleCountyLatLongClearFields();
                    }}
                    note={'Select Country or State/Province'}
                    error={locationCity.length < 1}
                    inputProps={{
                      className: 'search-bar',
                      onChange: (e) => handleCityChange(e),
                      onKeyPress: (e) => handleCityChange(e),
                      value: locationCity,
                      placeholder: 'Search',
                      error: locationCity.length < 1
                    }}
                  >
                    {citiesDropDown
                      .filter((city) =>
                        city.locationCity
                          ? city.locationCity.toLowerCase()
                            .slice(0, locationCity.trim().toLowerCase().length)
                          === locationCity.trim().toLowerCase()
                          : ''
                      )
                      .map((city, index) => (
                        <TypeaheadItem
                          id={index}
                          key={index}
                          value={city.locationCity}
                        >
                          <TypeaheadItemSuggestion>
                            <span>{`${city.locationCity} `}</span>
                          </TypeaheadItemSuggestion>
                        </TypeaheadItem>
                      ))}
                  </Typeahead>
                  <Button className='create-location-secondary'>
                    <SearchIcon size='small' />
                  </Button>
                </div>
              </form>
            </FieldBody>
          </Field>

          <TextInput
            style={{
              width: '170px',
              paddingRight: '15px',
              paddingLeft: '15px',
            }}
            label='Postal Code'
            placeholder=''
            value={locationPostalCode}
            onChange={(e) => {
              onChange('locationPostalCode', e.target.value);
              handleCountyLatLongClearFields();
            }}
          />
        </div>

        <div className='input-row lat-long'>
          <Button
            className='small-margin'
            variant='tertiary'
            size='small'
            style={{ padding: '40px 5px 0px 0px' }}
            onClick={populateLatLong}
          >
            + Auto-populate County and Lat/Long
          </Button>
          <Tooltip className='em-u-margin-half'>
            <TooltipPassage>
              <CircleQuestionMarkFilledIcon size='small' style={{ color: '#003366' }} />
            </TooltipPassage>
            <TooltipContent>
              Populates based on all address fields.
              <br />
              Street address, city, and country are required.
            </TooltipContent>
          </Tooltip>
        </div>
        <div className='input-row'>
          <TextInput
            className='county-lat-long'
            label='County'
            placeholder=''
            value={locationCounty.toString()}
            onChange={(e) => onChange('locationCounty', e.target.value)}
          />
          <TextInput
            className='county-lat-long'
            label='Latitude'
            placeholder=''
            value={latitude.toString()}
            onChange={(e) => onChange('latitude', e.target.value)}
          />
          <TextInput
            className='county-lat-long'
            label='Longitude'
            placeholder=''
            value={longitude.toString()}
            onChange={(e) => onChange('longitude', e.target.value)}
          />
        </div>

        <Select
          style={{ height: '55px' }}
          selectProps={{
            className: 'timezone',
          }}
          label='Timezone'
          value={timezone.timezoneName}
          onChange={(e) => {
            onChange('timezone', {
              timezoneId: `${e.target.options[e.target.selectedIndex].id}`,
              timezoneName: e.target.value,
            });
          }}
        >
          <option value=''>Select</option>
          {timezoneDropdown.map(renderTimezoneDropdown)}
        </Select>
      </Fieldset>

      <Fieldset>
        <TextArea
          className='description'
          label='Location Description'
          rows='3'
          placeholder=''
          value={locationDesc}
          onChange={(e) => handleDescription(e.target.value)}
        />
        <p style={{ fontSize: 'small' }}>
          Characters Remaining: {descMax - locationDesc.length}
        </p>
      </Fieldset>
      <RealEstateInterestWrapper
        {...props}
        locationStateLocationId={locationStateLocationId}
        handlePageError={handlePageError}
      />
      
      <ProgressTabNavigator
        onNavigateForward={onNavigateForward}
      > 
      </ProgressTabNavigator>
    </div>
  );
}

export default CreateLocation;
